import React from 'react';
import { RModal, RModalFooter, RPillButton, RText } from 'recruit/components';

export interface PlanLimitDetail {
    plan_name: string;
    limit: number;
    current_count: number;
    message: string;
}

interface RPlanLimitModalProps {
    detail: PlanLimitDetail;
    onClose: () => void;
}

export function RPlanLimitModal({ detail, onClose }: RPlanLimitModalProps) {
    return (
        <RModal title="Plan limit reached" onClose={onClose}>
            <RText lineHeight="relaxed">{detail.message}</RText>
            <RModalFooter>
                <RPillButton variant="secondary" onClick={onClose}>
                    Cancel
                </RPillButton>
                <RPillButton to="/recruit/settings/billing">View billing</RPillButton>
            </RModalFooter>
        </RModal>
    );
}
